'use strict';
// https://github.com/tc39/proposal-accessible-object-hasownproperty
require('../modules/esnext.object.has-own');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/accessible-object-hasownproperty.js
// module id = 966
// module chunks = 31